const ENV_CATEGORIES = {
  dev: 'dev',
  staging: 'staging',
  live: 'live'
}

const environments = {
  local: {
    category: ENV_CATEGORIES.dev,
    name: 'local'
  },
  dev: {
    category: ENV_CATEGORIES.dev,
    name: 'development'
  },
  ppc1: {
    category: ENV_CATEGORIES.staging,
    name: 'ppc1'
  },
  ppc2: {
    category: ENV_CATEGORIES.staging,
    name: 'ppc2'
  },
  ppc3: {
    category: ENV_CATEGORIES.staging,
    name: 'ppc3'
  },
  ppc21: {
    category: ENV_CATEGORIES.staging,
    name: 'ppc21'
  },
  pp21: {
    category: ENV_CATEGORIES.staging,
    name: 'pp21'
  },
  npe00: {
    category: ENV_CATEGORIES.staging,
    name: 'npe00'
  },
  npe01: {
    category: ENV_CATEGORIES.staging,
    name: 'npe01'
  },
  pp1: {
    category: ENV_CATEGORIES.staging,
    name: 'pp1'
  },
  int03: {
    category: ENV_CATEGORIES.staging,
    name: 'int03'
  },
  int08: {
    category: ENV_CATEGORIES.staging,
    name: 'int08'
  },
  int09: {
    category: ENV_CATEGORIES.staging,
    name: 'int09'
  },
  int10: {
    category: ENV_CATEGORIES.staging,
    name: 'int10'
  },
  live: {
    category: ENV_CATEGORIES.live,
    name: 'live'
  },
  prd00: {
    category: ENV_CATEGORIES.live,
    name: 'live'
  }
}

module.exports = { environments, ENV_CATEGORIES }
